'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionKeys = undefined;

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promotionKeys = exports.promotionKeys = (0, _keyMirror2.default)({
  BRAZIL: null,
  HSFS_SEED: null,
  HSFS_SERIES_A: null,
  HSFX_ENTREPRENEUR: null,
  INDIA: null,
  NO_PROMOTION: null
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/Promotions.js
// module id = 290
// module chunks = 3 4 5